import {
  Component,
  Input,
  Injector,
  OnChanges,
  Output,
  EventEmitter,
  SimpleChanges,
  Type,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
} from '@angular/core';

@Component({
  selector: 'app-dashboard-form-wrapper',
  template: '<ng-template #container></ng-template>',
})
export class DashboardFormWrapperComponent implements OnChanges {
  @Input() component!: Type<unknown>;

  @Input() data!: unknown;

  @Output() dataChange = new EventEmitter<unknown>();

  @ViewChild('container', { read: ViewContainerRef, static: true })
    container!: ViewContainerRef;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private componentRef!: ComponentRef<any>;

  private lastComponent!: Type<unknown>;

  private lastData!: unknown;

  constructor(private injector: Injector) {}

  ngOnChanges(changes: SimpleChanges): void {
    const componentChanged = changes['component'] && changes['component'].currentValue !== this.lastComponent;
    const dataChanged = changes['data'] && changes['data'].currentValue !== this.lastData;

    if (componentChanged || !this.componentRef) {
      this.loadComponent();
    } else if (dataChanged && this.componentRef?.instance?.form?.patchValue) {
      this.componentRef.instance.form.patchValue(this.data, { emitEvent: false });
    }

    this.lastComponent = this.component;
    this.lastData = this.data;
  }

  private loadComponent() {
    this.container.clear();

    const customInjector = Injector.create({
      providers: [{ provide: 'formData', useValue: this.data }],
      parent: this.injector,
    });

    this.componentRef = this.container.createComponent(this.component, {
      injector: customInjector,
    });

    if (this.componentRef.instance.dataChange) {
      this.componentRef.instance.dataChange.subscribe((updatedData: unknown) => {
        this.dataChange.emit(updatedData);
      });
    }
  }
}
